/**
 * Controller: ReportsCreateShowMessageModal
 */
angular.module('acme.view.application.reports.create.showMessageModal.controllers', [])
// Default button text; overridden when a modal provides a `saveText` resolve.
.value('saveText', 'Done')
.controller('ReportsCreateShowMessageModalController', [ '$scope', '$sce', '$uibModalInstance', 'currentMessage', 'currentTitle', 'safe', 'saveText', function ($scope, $sce, $uibModalInstance, currentMessage, currentTitle, safe, saveText) {

    $scope.errors = [];

    $scope.model = [];

    $scope.init = function() {
      $scope.model = (safe) ? $sce.trustAsHtml(currentMessage) : currentMessage;
      $scope.title = currentTitle;
      $scope.saveText = saveText;
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close();
    };

    $scope.init();

  }]);